import { useForm, useStore } from '@tanstack/react-form'
import { isNil, omitBy } from 'lodash'
import isEqual from 'lodash/isEqual'
import { FF } from 'ui/components'
import { SearchInputDebounced } from 'ui/components/InputV2'
import { CompanySelect } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { ClientUsersListFilterParams, clientUsersListFilterParamsSchema } from '~bank-client-users/types'

import { useClientUsersListContext } from '../../../../context/ClientUsersListContext'

import * as SC from './styles'

export const Filter = () => {
  const { data, state, navigate, clear } = useClientUsersListContext()

  const formApi = useForm({
    defaultValues: {
      companyId: state.companyId || 'all',
      searchString: state.searchString
    } as Pick<ClientUsersListFilterParams, 'companyId' | 'searchString'>
  })

  const updateSearchParams = (newValue: Partial<ClientUsersListFilterParams>) => navigate({ ...newValue, page: 1 })

  const handleCompanyIdChange = (value: string | number | null | undefined) => {
    if (value === 'all') {
      updateSearchParams({ companyId: null, myCompaniesOnly: false })
    } else if (value === 'my') {
      updateSearchParams({ companyId: null, myCompaniesOnly: true })
    } else {
      updateSearchParams({ companyId: value, myCompaniesOnly: false })
    }
  }

  const clearForm = () => {
    formApi.reset()
    clear()
  }

  return (
    <FilterPanel
      isDirty={
        useStore(formApi.store, (s) => s.isDirty) ||
        !isEqual(omitBy(clientUsersListFilterParamsSchema.parse({}), isNil), omitBy(state, isNil))
      }
      onReset={clearForm}
    >
      <SC.Columns>
        <div style={{ width: '225px' }}>
          <formApi.Field
            name="searchString"
            validators={{
              onChange: ({ value }) => {
                updateSearchParams({ searchString: value })
                return undefined
              }
            }}
            children={(field) => (
              <FF
                label="Search"
                field={field}
                input={(inputProps) => <SearchInputDebounced data-qa="Search" label="Search" {...inputProps} />}
              />
            )}
          />
        </div>
        <SC.Column>
          <formApi.Field
            name="companyId"
            validators={{
              onChange: ({ value }) => {
                handleCompanyIdChange(value)
                return undefined
              }
            }}
            children={(field) => (
              <FF
                label="Relationship"
                field={field}
                input={(inputProps) => (
                  <CompanySelect
                    searchable
                    hideMyCompaniesFilter
                    preloadedOptions={data.relationshipsToAssign}
                    {...inputProps}
                  />
                )}
              />
            )}
          />
        </SC.Column>
      </SC.Columns>
    </FilterPanel>
  )
}
